export default {"src":"/_next/static/media/dashboard.5c6dff3f.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};